import { ROLES } from './Role'


/**
 * 消息类型 
 */
var SESSION_TYPE = {
  work: {
    type: 'work',
    name: '工作通知',
    icon: 'imgs/svg/eds/workmessage.svg',
  },
  system: {
    type: 'system',
    name: '系统公告',
    icon: 'imgs/svg/eds/notifications.svg',
  },
}

/**
 * 消息类型 
 */
var MESSAGES_TYPE = {
  text: {
    type: 'text',
    name: '一般文本消息',
    icon: 'assignment',
    color: 'green'
  },
  link: {
    type: 'link',
    name: '链接消息',
    icon: 'assignment',
    color: 'green'
  },
  task_notify: {
    type: 'task_notify',
    name: '流程审批任务消息',
    icon: 'assignment',
    color: 'green'
  },
  flow_notify: {
    type: 'flow_notify',
    name: '流程审批提醒',
    icon: 'assignment',
    color: 'green'
  },
}

export { SESSION_TYPE, MESSAGES_TYPE }
